import { makeActionHandler } from "./_reducerUtils";

const certificationReducer = {
  initialState: {
    certification: {
      list: [],
      filter:{},
      isLoaded: false,
      isLoading: false,
      isQueryProcessing: false,
      isRefreshing: false,
      isDataOutdated: false,
      invalidationVersion: 0
    },
  },
  handlers: {
    "certification/SET_LIST": makeActionHandler("certification"),
    "RESET_ALL": () => certificationReducer.initialState
  }
};

export default certificationReducer;
